import React from 'react'
export interface IGoogleAnalyticsProps {
  Script: React.FC<any>
  measurementId?: string
}

export const GoogleAnalytics: React.FC<IGoogleAnalyticsProps> = ({
  Script,
  measurementId
}) => {
  if (!measurementId) return <></>
  return (
    <div className="container">
      <Script
        src={`https://www.googletagmanager.com/gtag/js?id=${measurementId}`}
      />
      <Script id="google-analytics">
        {`
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', '${measurementId}');
        `}
      </Script>
    </div>
  )
}
